import { render, staticRenderFns } from "./Modal.Folder.Action.Delete.vue?vue&type=template&id=5f190c9e&scoped=true&"
import script from "./Modal.Folder.Action.Delete.vue?vue&type=script&lang=js&"
export * from "./Modal.Folder.Action.Delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f190c9e",
  null
  
)

export default component.exports